<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-4 pb-4 mb-2">
        <h2>{{ $t('Susipažinimas su saugos dokumentais') }}</h2>
      </v-card-title>
      <v-card-text
        @scroll="scrollReadCheck($event)"
        style="max-height: 26rem; overflow: auto"
        class="pt-2 pb-2"
      >
        <template>
          <v-card
            v-for="(item, index) in userAgreementsData"
            :key="index"
            class="mb-2 py-0"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col class="pb-2" cols="12" md="12">
                  <span>{{ item.title }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <el-PDF-viewer :file="item" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-tooltip v-if="showReadUnderstood" top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <el-checkbox
                required
                :disabled="showReadUnderstood"
                class="pt-0 mt-0"
                label="Su saugos dokumentais susipažinau"
                v-model="formData.read_understood"
              >
              </el-checkbox>
            </div>
          </template>
          <span>{{
            $t('Prieš žymint privaloma perskaityti dokumentus.')
          }}</span>
        </v-tooltip>
        <el-checkbox
          v-if="!showReadUnderstood"
          required
          class="pt-0 mt-0"
          label="Su saugos dokumentais susipažinau"
          v-model="formData.read_understood"
        >
        </el-checkbox>
        <v-spacer></v-spacer>
        <el-button
          color="danger"
          @click.native="cancel()"
          :loading="loading"
          title="Nesutinku"
        />
        <el-button
          color="primary"
          @click.native.stop="submit()"
          :loading="loading"
          title="Sutinku"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalIregAgreement',
  props: {
    value: Boolean,
    loading: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      content: null,
      pdfFile: {},
      agreements: [],
      readCheck: false,
      formData: {
        read_understood: false,
      },
    }
  },
  computed: {
    ...mapGetters(['userAgreementsData']),
    showReadUnderstood() {
      return !this.readCheck
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {},
  methods: {
    scrollReadCheck(e) {
      let { scrollTop, clientHeight, scrollHeight } = e.target
      if (
        !this.readCheck &&
        scrollTop + clientHeight >= (scrollHeight * 4) / 5
      ) {
        this.readCheck = true
      }
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let ids = this.userAgreementsData.map((item) => {
            return item.id
          })
          this.$emit('confirmAgreement', ids)
          this.closeModal()
        } else {
          this.$root.$emit('DATA_ERROR_CODE', '000101')
        }
      })
    },
    cancel() {
      this.$emit('cancelAgreement')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
